var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOnline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6,8.77l-1.57,1.81c-2.42-2.1-5.57-3.39-9.03-3.39s-6.6,1.28-9.03,3.39l-1.57-1.81c2.84-2.47,6.54-3.97,10.6-3.97s7.75,1.51,10.6,3.97ZM5.33,13.3l1.57,1.81c1.37-1.19,3.15-1.91,5.1-1.91s3.73.73,5.1,1.91l1.57-1.81c-1.79-1.55-4.12-2.5-6.67-2.5s-4.88.95-6.67,2.5ZM9.26,17.84l2.74,3.16,2.74-3.16c-.74-.64-1.69-1.04-2.74-1.04s-2,.4-2.74,1.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOnline);
export default __webpack_public_path__ + "static/1776335122/media/icon-online.9f160c84ba0e967a807ccd8ab0557ff1.svg";
export { ForwardRef as ReactComponent };